import { createStore } from "vuex";
import clients from "./defaultClientsData";
export default createStore({
  state: {
    lang: "ar",
    ar: {
      navbarTitles: {
        home: {
          name: "الرئيسية",
          route: "/",
        },
        ourWorks: {
          name: "أعمالنا",
          route: "/projects",
        },
        ourClients: {
          name: "عملائنا",
          route: "/clients",
        },
        whoWeAre: {
          name: "من نحن",
          route: "/about",
        },
        policies: {
          name: "سياسة الاستخدام",
          route: "/policies",
        },
        contactUs: {
          name: "تواصل معنا",
          route: "/contact",
        },
      },
      homePage: {
        heroSection: [
          {
            title: "برنامج ادارة محلات البلايستيشن والمطاعم",
            btnText: "معرفة المزيد",
            btnNavigationLink: "/projects/1",
            image_name: "ps.png",
            image_alt: "Ps Software Landing page",
          },
          {
            title: "برنامج ادارة محلات البصريات",
            btnText: "معرفة المزيد",
            btnNavigationLink: "/projects/2",
            image_name: "sun.png",
            image_alt: "Sunglasses Software Landing page",
          },
          {
            title: "برنامج ادارة الكافيهات والكاشير",
            btnText: "معرفة المزيد",
            btnNavigationLink: "/projects/3",
            image_name: "cafe.png",
            image_alt: "Cafe Software Landing page",
          },
          {
            title: "برنامج ادارة متاجر بيع الكروت الرقمية",
            btnText: "معرفة المزيد",
            btnNavigationLink: "/projects/4",
            image_name: "carts.png",
            image_alt: "Ps Software Landing page",
          },
        ],
        startYourProject: {
          title: "تريد أن تبدأ مشروع؟",
          desc: "سنكون سعداء بمساعدتك في فكرتك, ابقى علي تواصل.",
          btnText: "قدم طلبك معنا",
          btnNavigationLink: "/contact",
        },
      },
      contactUsContent: {
        header: "تواصل معنا",
        formData: {
          namePlaceHolder: "الاسم",
          phonePlaceHolder: "الموبايل",
          emailPlaceHolder: "البريد الإلكتروني",
          messageTitlePlaceHolder: "عنوان الرسالة",
          messagePlaceHolder: "الرسالة",
          buttonText: "راسلنا",
        },
        alertMessages: {
          dataRequired: {
            title: "جميع البيانات مطلوبة",
            text: "",
            buttonText: "تم ",
          },
          inValidEmail: {
            title: "الايميل غير صحيح",
            text: "example@domain.com",
            buttonText: "تم ",
          },
          submitSuccess: {
            title: "تم ارسال الطلب",
            text: "سيتم التواصل معك في اقرب وقت",
            buttonText: "تم ",
          },
        },
      },
      projects: {
        data: [
          {
            id: 1,
            title: "برنامج ادارة محلات البلايستيشن والمطاعم",
            description: `برنامج ادارة محلات البلايستيشن والمطاعم والكافيهات بشكل سهل وبسيط، متابعة مستمرة للايرادات اليومية والسنوية، تقارير مفصلة عن التعاملات المالية، تقاير كاملة عن المنتجات الاكثر مبيعا ونسبة ربح كل منتج، قاعدة بيانات للزائرين مع امكانية عمل عروض مخصصة لهم مع المزيد من الخصائص لاستخدام سهل وفعال.`,
            img: "PS01.png",
            headerImage: "PS Gaming.png",
            buttonText: "مزيد من التفاصيل",
            descriptionVideoLink: "https://www.youtube.com/embed/CCXX5g0_iuQ",
            trailerVersoinLink:
              "https://github.com/CodeClinic-EG/releases/releases/download/v7.2.0/PS_Restaurant_windows-x32_7_2_0.exe",
            spacificationList: [
              {
                name: "مكونات",
                description: "تصنيع المنتج من خلال سحب مكوناته من المخزن",
                icon: "fa fa-hamburger",
              },
              {
                name: "احصائيات",
                description:
                  "عرض إحصائيات للمنتجات والمبيعات وتقارير لفترات زمنية مختلفة",
                icon: "fa-solid fa-chart-pie",
              },
              {
                name: "بيانات العملاء",
                description:
                  "تخزين وادارة بيانات العملاء عن طريق متابعة عمليات الشراء التي قاموا بها والمدة التي  زاروا فيها المكان",
                icon: "fas fa-users",
              },
              {
                name: "ارشيف",
                description: "تخزين جميع البيانات علي مدار فترة الاستخدام ",
                icon: "fas fa-archive",
              },
              {
                name: "عروض",
                description:
                  "انشاء عرض للعملاء علي جهاز مُحدد او فترة لعب مُحددة",
                icon: "fas fa-tags",
              },
              {
                name: "خصومات",
                description: "انشاء خصم علي فواتير الكافيه او اللعب حسب الرغبة",
                icon: "fas fa-sack-dollar",
              },
              {
                name: "بيانات الفاتورة",
                description:
                  "التحكم في بيانات الفاتورة وتغيير الاسم والعنوان واللوجو الخاص بالفرع",
                icon: "fas fa-receipt",
              },
              {
                name: "المصروفات",
                description: "تنظيم المصروفات اليومية وتخزينها في الارشيف",
                icon: "fas fa-money-bill-1-wave",
              },
              {
                name: "خاصية منع السرقة",
                description:
                  "خاصية منع السرقة عن طريق تتبع تعاملات الموظف وتسجيلها لحظة بلحظة",
                icon: "fas fa-user-secret",
              },
              {
                name: "دعم فني 24/7",
                description: "الرد على الاستفسارات والتساؤلات",
                icon: "fas fa-headset",
              },
            ],
            pricingList: [
              {
                name: "بلايستيشن",
                spacificationList: [
                  "تيك آوي",
                  "مصروفات",
                  "عدد منتجات غير محدود",
                  "مخزن",
                  "احصائيات و ارشيف",
                  "تقارير وفواتير",
                  "10 غرف لعب",
                  "عدد أجهزة غير محدود",
                  "عدد مستخدمين غير محدود",
                ],
                costInUSD: "101.72",
                costInEGP: "4000",
                btnText: "طلب النسخة",
              },
              {
                name: "بلايستيشن برو",
                spacificationList: [
                  " نسخة البلايستيشن",
                  "عروض  علي الأجهزة",
                  "عروض للعملاء علي الساعات",
                  "حجز غرف اللعب",
                  "بيانات العملاء",
                  "باركود",
                  "15 غرفة لعب",
                  "فاتورة المطبخ",
                  "ارسال تقارير يومية",
                  "اعدادات اخرى",
                  "صيانة واحدة مجانية",
                ],
                costInUSD: "203.45",
                costInEGP: "6000",
                btnText: "طلب النسخة",
              },
              {
                name: "بلايستيشن مطعم",
                spacificationList: [
                  "نسخة بلايستيشن برو",
                  "ادارة البيانات",
                  "تقسيم فواتير المطعم",
                  "تصدير بيانات العملاء والمخزن",
                  "تحكم في بيانات الفاتورة",
                  "عدد طاولات غير محدود",
                  "عدد غرف لعب غير محدود",
                  "فاتورة تقفيل اليوم تفصيلية",
                  "احصائيات اللعب",
                  "احصائيات معدل الفواتير",
                  "ثلاث صيانات مجانية",
                ],
                costInUSD: "254.32",
                costInEGP: "7000",
                btnText: "طلب النسخة",
              },
            ],
            aboutProgram: [
              "إدارة أجهزة البلايستيشن مع إصدار تنبيه عند إنتهاء الوقت المحدد",
              "تقارير مفصلة بالمبيعات لليوم والشهر أو أي فتره محددة",
              "متابعة حركات سحب وتوريد المنتجات والمخزون الحالي لكل منتج",
              "منافذ بيع متعددة للمطعم (تيك آوي - صالة - بار - دليڤري)",
              "قاعدة بيانات للعملاء وجميع مشترياتهم مع إمكانية عمل عروض وخصومات مميزة لبعض العملاء",
              "حجز أجهزة البلايستيشن للعملاء المسجلين",
              "معرفة المنتجات الأكثر مبيعًا من خلال تقرير الإحصائيات المفصل",
            ],
            designYourNeeds_: {
              img: "PS02.png",
              description:
                "يمكنك أن تصمم نسختك بالسعر المناسب لك وتختار المميزات التي تحتاجها فقط في البرنامج",
              buttonText: "أبدا التصميم",
              designYourNeedsMessage:
                "اجمالي سعر النسخة طبقا للمميزات المختارة =",
              basePrice: 1500,
              data: {
                // { name: "صالة اللعب", fixed: true },
                مطعم: [
                  { name: "تيك آوي", price: 250, fixed: false },
                  { name: "بار للمطعم", price: 150 },
                  { name: "تقسيم فاتورة المطعم", price: 200 },
                  {
                    name: "عدد طاولات",
                    price: 150,
                    type: "numeric",
                    opposite: ["عدد طاولات غير محدود"],
                  },
                  {
                    name: "عدد طاولات غير محدود",
                    price: 500,
                    opposite: ["عدد طاولات"],
                  },
                ],
                بلايستيشن: [
                  //   { name: "عدد أجهزة لعب غير محدودة", fixed: true, },
                  { name: "طباعة فاتورة بدون مغادرة", fixed: true },
                  {
                    name: "عدد غرف اللعب",
                    price: 150,
                    type: "numeric",
                    opposite: ["عدد غرف اللعب غير محدود"],
                  },
                  {
                    name: "عدد غرف اللعب غير محدود",
                    price: 500,
                    opposite: ["عدد غرف اللعب"],
                  },
                  {
                    name: "عروض الساعات",
                    price: 100,
                    dependsOn: ["بيانات عملاء"],
                  },
                  { name: "عروض الأجهزة", price: 100 },
                  { name: "احصائيات اللعب", price: 200 },
                  {
                    name: "حجز غرف اللعب",
                    price: 500,
                    dependsOn: ["بيانات عملاء"],
                  },
                  {
                    name: "خصم لقيمة اللعب منفصل عن طلبات الكافيه",
                    price: 200,
                  },
                  { name: "عروض علي الوقت (ساعتين عليهم ساعه)", price: 400 },
                  { name: "تثبيت الاجهزة", price: 175 },
                ],
                عام: [
                  { name: "مصروفات", fixed: true },
                  { name: "منيو", fixed: true },
                  { name: "مخزن", fixed: true },
                  { name: "عدد منتجات غير محدود", fixed: true },
                  { name: "احصائيات", fixed: true },
                  { name: "ارشيف", fixed: true },
                  { name: "تقارير وفواتير", fixed: true },
                  { name: "عدد موظفين غير محدود", fixed: true },
                  {
                    name: "بيانات عملاء",
                    price: 200,
                    existWith: [
                      "عروض الساعات",
                      "عروض الأجهزة",
                      "حجز غرف اللعب",
                    ],
                  },
                  { name: "باركود", price: 200 },
                  { name: "تحكم في بيانات الفاتورة", price: 200 },
                  { name: "ادارة البيانات", price: 150 },
                  { name: "تصدير بيانات العملاء والمخزن", price: 200 },
                  { name: "فاتورة تقفيل اليوم تفصيلية", price: 200 },
                  { name: "اعدادات أخرى", price: 100 },
                  { name: "احصائيات معدل الفواتير", price: 100 },
                  { name: "فاتورة المطبخ", price: 450 },
                  { name: "ارسال تقارير يومية", price: 275 },
                  { name: "اختيار طرق دفع متعددة", price: 300 },
                  { name: "تقارير يومية بالخصومات", price: 175 },
                  { name: "تحويل الطلبات من المطعم للعب", price: 150 },
                ],
              },
              alertMessages: {
                dataRequired: {
                  title: "جميع البيانات مطلوبة",
                  text: "",
                  buttonText: "تم ",
                },
                inValidEmail: {
                  title: "الايميل غير صحيح",
                  text: "example@domain.com",
                  buttonText: "تم ",
                },
                submitSuccess: {
                  title: "تم ارسال الطلب",
                  text: "سيتم التواصل معك في اقرب وقت",
                  buttonText: "تم ",
                },
              },
            },
            orderTacker: {
              title: `طلب الاوردرات عن بعد من خلال الموبايل`,
              description: ` تحويل نمط طلب الاوردرات وتجربة العملاء الي شكل رقمي وحديث, التفاعل السلس والفعال عبر تطبيقنا للهواتف المحمولة لطلب الاوردرات عن بُعد دون الحجاحه لتدوينها بشكل ورقي `,
              spacifications: [
                `تمكن العملاء من طلب الاوردرات من الموبايل`,
                `تمكن العاملين من تسجيل الاوردرات من الموبايل`,
                `ارسال الاوردرات بشكل تلقائي الي الكاشير`,
                `متابعة حالة الطلب ومعرفة الحساب بشكل لحظي`,
              ],
              img: "order-tacker.png",
            },
          },
          {
            id: 2,
            title: "برنامج ادارة محلات البصريات",
            description: `إدارة محلات البصريات بالطريقة الأكثر سهولة وفعالية، تاريخ مرضي لكل حالة، تقارير عن المنتج الطبي الأكثر شيوعا، جرد تفصيلي للمخازن، فواتير مميزة مع سهولة تعديل البيانات، حفظ بياناتك لحظيا مع استخدام البرنامج، عدد مستخدمين غير محدد بصلاحيات متعددة، والمزيد من الخصائص المتميزة والحصرية.`,
            img: "Sunglasses03.png",
            headerImage: "sunglasses.png",
            buttonText: "مزيد من التفاصيل",
            descriptionVideoLink: "https://www.youtube.com/embed/WavSss-P8z0",
            trailerVersoinLink:
              "https://github.com/CodeClinic-EG/releases/releases/download/v1.0/Sunglasses_windows-x32.exe",
            aboutProgram: [
              "قاعدة بيانات للعملاء وجميع مشترياتهم مع إمكانية عرض الكشوفات السابقة",
              "متابعة حركات سحب وتوريد المنتجات والمخزون الحالي لكل منتج مع تحميل شيت أكسل بنواقص المخزن",
              "امكانية البيع بالآجل للعملاء المسجلين",
              "التحكم في بيانات الفواتير وحجمها",
              "ارشيف جميع التعاملات المالية علي مدار الاستخدام",
              "منفذ بيع جملة وقطاعي مع وضع سعر لكل حالة",
            ],
            spacificationList: [
              {
                name: "احصائيات",
                description:
                  "عرض إحصائيات للمنتجات والمبيعات وتقارير لفترات زمنية مختلفة",
                icon: "fa-solid fa-chart-pie",
              },
              {
                name: "بيانات العملاء",
                description:
                  "تخزين وادارة بيانات العملاء عن طريق متابعة عمليات الشراء التي قاموا بها ",
                icon: "fas fa-users",
              },
              {
                name: "ارشيف",
                description: "تخزين جميع البيانات علي مدار فترة الاستخدام ",
                icon: "fas fa-archive",
              },
              {
                name: "وضع الالوان",
                description: "متوفر بثلاث  الوان مختلفة مع الوضع الليلي",
                icon: "fas fa-moon",
              },
              {
                name: "بيانات الفاتورة",
                description:
                  "التحكم في بيانات الفاتورة وتغيير الاسم والعنوان واللوجو الخاص بالفرع",
                icon: "fas fa-receipt",
              },
              {
                name: "المصروفات",
                description: "تنظيم المصروفات اليومية وتخزينها في الارشيف",
                icon: "fas fa-money-bill-1-wave",
              },
              {
                name: "دعم فني 24/7",
                description: "الرد على الاستفسارات والتساؤلات",
                icon: "fas fa-headset",
              },
            ],
            pricingList: [
              {
                name: "برنامج ادارة البصريات",
                spacificationList: [
                  "منفذ بيع جملة",
                  "منفذ بيع قطاعي",
                  "مصاريف",
                  "منيو",
                  "احصائيات بعمليات البيع",
                  "التحكم في بيانات الفاتورة",
                  "جرد لحظي للمخزن",
                  "تصدير نواقص المخزن",
                  "بيانات العملاء",
                  "تاريخ مرضي لكل عميل",
                ],
                costInUSD: "127.16",
                costInEGP: "3999",
                btnText: "طلب النسخة",
              },
            ],
          },
          {
            id: 3,
            title: "برنامج ادارة الكافيهات والكاشير",
            description: `سهولة وسرعة فاختيار وتنفيذ الطلب، وجود نظام التارجت من خلال تجميع نقاط لكل منتج، تقارير مفصلة بحسابات الآجل لكل عميل، احصائيات وجرد للمخازن بصورة سهلة وبسيطة، وجود رقم سري لكل عميل لاستخدامه في طلب الاوردرات، والعديد من المميزات الأخرى.`,
            img: "Cafe01.png",
            headerImage: "waiter.png",
            buttonText: "مزيد من التفاصيل",
            trailerVersoinLink:
              "https://github.com/CodeClinic-EG/releases/releases/download/v1.0/Cafe-POS_windows-x32.exe",
            aboutProgram: [
              "التحكم في المصاريف وخصمها من الايراد اليومي",
              " ادارة طلبات الآجل و تقارير بالطلبات الآجلة للعملاء",
              "منفذ بيع خاص لكل من العملاء والموظفين والمديرين",
              "وجهات سهلة وسريعة تساعدك تنجز شغلك بشكل سريع ومنظم",
              " معرفة المنتجات الأكثر مبيعًا من خلال تقرير الإحصائيات المفصل",
            ],
            spacificationList: [
              {
                name: "مكونات",
                description: "تصنيع المنتج من خلال سحب مكوناته من المخزن",
                icon: "fas fa-cubes-stacked",
              },
              {
                name: " مشتريات العملاء",
                description: "معرفة قيمة الدخل من كل عميل بشكل مُنفصل",
                icon: "far fa-money-bill-alt",
              },
              {
                name: "اداء الموظفين",
                description:
                  "متابعة اداء الموظفين من خلال عدد النقاط المُحصلة خلال الشهر",
                icon: "fas fa-trophy",
              },
              {
                name: "المخزن",
                description: "تنبيه بالمنتجات اللتي اوشكت علي النفاذ",
                icon: "fas fa-bell",
              },
              {
                name: "احصائيات",
                description:
                  "عرض إحصائيات للمنتجات والمبيعات وتقارير لفترات زمنية مختلفة",
                icon: "fa-solid fa-chart-pie",
              },
              {
                name: "بيانات العملاء",
                description:
                  "تخزين وادارة بيانات العملاء عن طريق متابعة عمليات الشراء التي قاموا بها والطلبات المؤجلة",
                icon: "fas fa-users",
              },
              {
                name: "ارشيف",
                description: "تخزين جميع البيانات علي مدار فترة الاستخدام ",
                icon: "fas fa-archive",
              },
              {
                name: "خصومات",
                description: "انشاء خصم علي فواتير الكافيه او اللعب حسب الرغبة",
                icon: "fas fa-sack-dollar",
              },
              {
                name: "المصروفات",
                description: "تنظيم المصروفات اليومية وتخزينها في الارشيف",
                icon: "fas fa-money-bill-1-wave",
              },
              {
                name: "دعم فني 24/7",
                description: "الرد على الاستفسارات والتساؤلات",
                icon: "fas fa-headset",
              },
            ],
            pricingList: [
              {
                name: "برنامج ادارة الكافيهات و الكاشير",
                spacificationList: [
                  "احصائيات",
                  "تقارير",
                  "فواتير",
                  "بيانات العملاء",
                  "عدد منتجات غير محدود",
                  "عدد موظفين غير محدود",
                  "ارشيف بالمبيعات والمصروفات والأواجل",
                  "اضافة مواد خام لتصنيع المنتجات",
                  "منفذ بيع خاص بكل فئة عملاء",
                ],
                costInUSD: "152.59",
                costInEGP: "3000",
                btnText: "طلب النسخة",
              },
            ],
          },
          {
            id: 4,
            title: "برنامج ادارة متاجر بيع الكروت الرقمية",
            description: `إدارة كاملة لأنظمة الكروت ونقاط الشحن الاونلاين، إضافة وتعريف مخزون من خلال ملفات الأكسل، عدد مستخدمين غير محدود، واجهات بسيطة وفعالة، والعديد من المميزات الأخرى.`,
            img: "CardsStore01.png",
            headerImage: "card_store.png",
            buttonText: "مزيد من التفاصيل",
            aboutProgram: [
              "منفذ بيع كروت رقمية وغير رقمية",
              "أرشيف بكل المعاملات والمبيعات",
              "احصائيات مُفصلة بالمبيعات والمكاسب",
              "تقارير مُفصلة باليوم والشهر أو أي فتره محددة للمبيعات",
              "اضافة كروت رقمية من ملف خارجي",
            ],
            spacificationList: [
              {
                name: "احصائيات",
                description: "عرض إحصائيات لمبيعات الكروت لفترات زمنية مختلفة",
                icon: "fa-solid fa-chart-pie",
              },
              {
                name: "ارشيف",
                description: "تخزين جميع البيانات علي مدار فترة الاستخدام ",
                icon: "fas fa-archive",
              },
              {
                name: "خصومات",
                description: "انشاء خصم علي فواتير الكافيه او اللعب حسب الرغبة",
                icon: "fas fa-sack-dollar",
              },
              {
                name: "فواتير",
                description: "طباعة فاتورة لكل عملية بيع",
                icon: "fas fa-receipt",
              },
              {
                name: "تقارير",
                description:
                  "تقارير مُفصلة بالمبيعات والارباح علي مدار الاستخدام",
                icon: "fas fa-file-pdf",
              },
              {
                name: "خاصية منع السرقة",
                description:
                  "خاصية منع السرقة عن طريق تتبع تعاملات الموظف وتسجيلها لحظة بلحظة",
                icon: "fas fa-user-secret",
              },
              {
                name: "دعم فني 24/7",
                description: "الرد على الاستفسارات والتساؤلات",
                icon: "fas fa-headset",
              },
            ],
            pricingList: [
              {
                name: "برنامج ادارة الكروت",
                spacificationList: [
                  "مخزن",
                  "تقارير مبيعات",
                  "احصائيات",
                  "منفذ بيع الكروت الرقمية",
                  "منفذ بيع الكروت الغير رقمية",
                  "امكانية رفع كروت من ملف خاجي ",
                ],
                costInUSD: "127.16",
                costInEGP: "2500",
                btnText: "طلب النسخة",
              },
            ],
          },
        ],
        innerNavTitles: {
          about: {
            val: "عن البرنامج",
            download: false,
            href: "about",
            Hide: false,
          }, // Required
          advantages: {
            val: "مزايا البرنامج",
            download: false,
            href: "advantages",
            Hide: true,
          }, // Required
          descriptionVideo: {
            val: "شرح البرنامج",
            download: false,
            href: "descriptionVideo",
            Hide: true,
          }, // Optional
          pricing: {
            val: "الاسعار",
            download: false,
            href: "pricing",
            Hide: false,
          }, // Optional
          designYourNeeds: {
            val: "صمم نسختك",
            download: false,
            href: "designYourNeeds",
            Hide: true,
          }, // Optional
          download: {
            val: "النسخة التجريبية",
            download: true,
            href: "",
            Hide: false,
          }, // Optional
        },
        sectionsTitles: {
          about: "عن البرنامج",
          spacification: "مزايا البرنامج",
          description: "شرح البرنامج",
          pricing: "الاسعار",
          designYourNeeds: "صمم نسختك بالسعر المناسب لك",
        },
      },
      sendRequestData: {
        versionRequestFooterMessage: "اجمالي سعر ",
        cancleButtonText: "الغاء",
        nextButtonText: "التالي",
        backButtonText: "رجوع",
        submitButtonText: "ارسال الطلب",
        formPlaceHolders: {
          name: "الاسم",
          address: "العنوان",
          mobileNumber: "رقم الموبايل",
          email: "البريد الالكتروني",
        },
      },
      clients: [],
      isClientsDataLoad: false,
      about: [
        {
          title: "نبذة عن الكيان",
          content: `شركة للحلول البرمجية المتكالمة تأسست سنة 2019، تعمل في مختلف مجالات البرمجة الحديثة من تطبيقات سطح المكتب وتطوير وتصميم مواقع وتصميم تطبيقات الاندرويد`,
        },
        {
          title: "خدماتنا",
          content: `إنشاء وتصميم برامج سطح المكتب لمختلف المجالات بواجهات رسومية حديثة وسهلة، تصميم فواتير وتقارير بشكل يتلائم مع طبيعة عملك، تصميم مواقع ويب احترافية باحدث التكنولوجي، انشاء تطبيقات الهاتف بنظام الاندرويد بواجهات حديثة وفعالة`,
        },
        {
          title: "طرق الدفع المتاحة",
          content: `اورانج كاش - فودافون كاش - تحويلات بنكية - بايبال - ويسترن يونين`,
        },
        {
          title: "طرق التسليم",
          // content: `يتم تسليم العميل اونلاين من خلال برامج Teamviewer ، Anydesk ويتم التفعيل بعد الدفع`,
          content: [
            { type: "text", value: "يتم تسليم العميل اونلاين من خلال برنامج " },
            { type: "link", value: "Anydesk", link: "https://anydesk.com/" },
            { type: "text", value: " أو " },
            {
              type: "link",
              value: "TeamViewer",
              link: "https://www.teamviewer.com/",
            },
            { type: "text", value: " ويتم التفعيل بعد الدفع" },
          ],
        },
      ],
      policies: [
        {
          title: " سياسة الخصوصية 🕵🏾‍♀️",
          content: `أهلاً بك في سياسة الخصوصية لشركة Code Clinic. نحن نولي أهمية كبيرة لحماية خصوصية زوارنا وعملائنا، ونلتزم بتوفير بيئة آمنة وموثوقة لجميع المعلومات التي تتم جمعها منك واستخدامها. يرجى قراءة هذه السياسة بعناية لفهم كيفية جمع واستخدام وحماية المعلومات الشخصية.

          1. جمع المعلومات:
نقوم بجمع معلومات شخصية محدودة وضرورية فقط، وذلك عندما تقدمها لنا بناءً على رغبتك في استفادة من خدماتنا أو التواصل معنا. قد تتضمن هذه المعلومات الاسم وعنوان البريد الإلكتروني ورقم الهاتف وأية معلومات أخرى تقدمها طوعاً.
2. استخدام المعلومات:
نستخدم المعلومات الشخصية التي تقدمها لنا لتحسين خدماتنا وتقديمها بشكل أفضل، وللرد على استفساراتك وطلباتك، ولتوفير الدعم الفني والمساعدة. لا نقوم ببيع أو مشاركة معلوماتك الشخصية مع أي جهة خارجية دون موافقتك الصريحة.
3. الأمان والحفاظ على الخصوصية:
نحرص على تطبيق إجراءات أمان صارمة لحماية معلوماتك الشخصية من الوصول غير المصرح به والاستخدام الغير قانوني أو التعدي عليها. نحتفظ بمعلوماتك الشخصية لفترة محدودة وفقًا للغرض الذي تم جمعها من أجله.
4. ملفات تعريف الارتباط (كوكيز):
قد نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا وتخصيص المحتوى والإعلانات حسب احتياجاتك. يمكنك التحكم في إعدادات ملفات تعريف الارتباط عبر متصفح الويب الخاص بك.
5. الروابط إلى مواقع الطرف الثالث:
قد تحتوي موقعنا على روابط إلى مواقع الطرف الثالث التي قد تختلف في سياسات الخصوصية عن سياسة Code Clinic. ننصحك بمراجعة سياسات الخصوصية لهذه المواقع قبل تقديم أي معلومات شخصية.

نحتفظ بالحق في تحديث سياسة الخصوصية من وقت لآخر، وسيتم إشعارك بأي تغييرات تطرأ على هذه السياسة. إذا كنت بحاجة إلى مزيد من المعلومات حول سياسة الخصوصية أو لديك أي استفسارات، يرجى التواصل معنا عبر وسائل الاتصال المتاحة على موقعنا.

نشكرك على ثقتك بنا ونعدك بأننا سنستمر في العمل بكل جدية ومسؤولية لحماية خصوصيتك وتقديم خدماتنا بأفضل مستوى ممكن.`,
        },
        {
          title: " سياسة الاستخدام 👥",
          content: `مرحبًا بك في سياسة الاستخدام لشركة Code Clinic. يهدف هذا الوثيقة إلى توضيح الشروط والأحكام التي يجب الالتزام بها عند استخدام موقعنا وخدماتنا. يُرجى قراءة هذه السياسة بعناية وفهم القواعد التي تحكم التفاعل معنا.

          1. الالتزام بالقوانين والتنظيمات:
          عند استخدام موقع Code Clinic وخدماتنا، يجب عليك الالتزام بجميع القوانين والتنظيمات المعمول بها. يُحظر عليك استخدام خدماتنا بأي طريقة تنتهك القوانين المحلية أو الدولية أو تنتهك حقوق الغير.
          2. المحتوى والملكية الفكرية:
          يحتوي موقع Code Clinic على محتوى محمي بحقوق الملكية الفكرية، بما في ذلك النصوص والصور والشعارات والعلامات التجارية والبرمجيات. يُمنع نسخ أو توزيع أو استخدام أي جزء من المحتوى دون الحصول على إذن كتابي مسبق منا.
          3. التسجيل والحسابات:
          قد يتطلب استخدام بعض خدماتنا التسجيل وإنشاء حساب مستخدم. يجب أن تقدم معلومات دقيقة ومحدثة عند التسجيل، ويجب أن تحمي معلومات الدخول إلى حسابك وعدم مشاركتها مع الآخرين.
          4. استخدام الخدمات:
          تقدم Code Clinic خدمات برمجية وتصميمية متنوعة. يُمنع استخدام خدماتنا بطريقة تعطّلها أو تعيق عملها أو تسبب ضررًا للمستخدمين الآخرين. يُحظر أيضًا استخدام خدماتنا لنشر محتوى غير قانوني أو مسيء أو ضار أو مخل بالآداب.
          5. السرية والخصوصية:
          نحترم خصوصية المستخدمين ونلتزم بحماية المعلومات الشخصية التي يقدمونها لنا. يُمنع منح أو مشاركة معلومات المستخدمين مع أطراف ثالثة دون موافقتهم الصريحة.
          6. تغييرات سياسة الاستخدام:
          قد نقوم بتحديث سياسة الاستخدام من وقت لآخر، وسيتم إشعارك بأي تغييرات تطرأ على هذه السياسة. يُرجى مراجعة هذه السياسة بشكل دوري للبقاء على دراية بالتغييرات.
          7. الدعم الفني والتواصل:
          نحن نسعى لتقديم أفضل دعم فني لكل عميل. إذا كنت بحاجة إلى المساعدة أو لديك استفسارات، يُرجى التواصل معنا عبر وسائل الاتصال المتاحة على موقعنا.

          شكرًا لك على استخدام خدماتنا. نحن نتطلع دائمًا إلى تقديم تجربة مرضية ومفيدة لك. إذا كنت توافق على هذه الشروط والأحكام، فيُرجى متابعة استخدام خدماتنا بكل ثقة واطمئنان.`,
        },
        {
          title: " سياسة الاسترجاع ↩️",
          content: `نحن في Code Clinic نهتم بتقديم منتجات ذات جودة عالية ونعتز برضا عملائنا. إذا كنت لا تكون راضيًا عن البرنامج الذي قمت بشرائه، فإليك سياسة الاسترجاع التي يمكن أن تستفيد منها:

1. النسخة التجريبية:
    
    يرجى الاطلاع على سياسة الاسترجاع بعناية قبل شراء البرنامج. تختلف سياسة الاسترجاع من شركة لأخرى وقد تشمل معايير مختلفة للمستردات والتكاليف المحتملة. لتجنب أي رسوم إضافية وللتأكد من أن البرنامج يلبي احتياجاتك، **يوصى دائمًا باستخدام النسخة التجريبية المجانية لمدة 30 يومًا قبل أن تقرر الشراء**.
    
2. فترة الاسترجاع:
نقدم فترة استرجاع مجانية تستمر لمدة 14 يومًا من تاريخ الشراء. خلال هذه الفترة، يحق لك طلب استرداد 40% من المبلغ المدفوع.
3. الشروط للاسترجاع:
- يجب أن تقدم طلب الاسترجاع خلال فترة الاسترجاع المحددة والتي تستمر لمدة 14 يومًا.
- يجب أن يكون البرنامج الذي قمت بشرائه لا يزال غير مستخدمًا بشكل كامل وأن تكون قد قمت بإلغاء تنشيط البرنامج بشكل صحيح.
- يجب أن تراعي قواعد الاستخدام العادل وأن لا تكون قد خرقت الاتفاقية الترخيص للبرنامج.
1. النسبة المستردة:
عند طلب استرجاع المبلغ خلال فترة الاسترجاع، سيتم خصم نسبة 60% من المبلغ المدفوع ويتم استرداد الباقي 40% من المبلغ.
2. التواصل مع الدعم الفني:
في حالة الاستفسار عن تفاصيل سياسة الاسترجاع والنسبة المستردة والتكاليف المحتملة، يُنصح دائمًا بالتواصل مع فريق الدعم الفني لدينا للحصول على معلومات دقيقة وشاملة حول هذا الموضوع.

نحن نسعى دائمًا لتوفير تجربة تعامل مريحة ومرضية لعملائنا، وسياسة الاسترجاع تعكس التزامنا بتقديم الحلول المناسبة والشفافة لكافة المستخدمين. نحن نقدر تفهمك ودعمك لمنتجاتنا، ونتطلع لخدمتك بأفضل شكل ممكن.`,
        },
      ],
      footerContent: {
        email: "codeclinicstartup@gmail.com",
        phoneNumber: "(+2) 01288656950",
        logoCaption: "Code Clinic | For Software Solutions",
        copyRightText: "Copyright © Code Clinic 2024",
        socialLinks: {
          facebook: "https://www.facebook.com/CodeClinicEG/",
          instagram: "https://www.instagram.com/codecliniceg/",
          youtube: "https://www.youtube.com/@CodeClinic",
        },
      },
      currency: "ج.م",
      usdRate: -1,
    },
  },
  mutations: {
    setUSDRate(state, val) {
      state[state.lang].usdRate = val;
    },
    setClientData(state, clientsData) {
      if (clientsData?.length > 0) {
        state[state.lang].clients = clientsData;
      }
    },
    selClientDataLoaded(state, val) {
      console.log("valll ", val);
      state[state.lang].isClientsDataLoad = val;
    },
  },
  actions: {
    async fetchUSDRate() {
      try {
        const response = await fetch(
          "https://api.currencyfreaks.com/latest?apikey=334aff90af8f4be891c4a26fae04d132",
          {
            method: "GET",
          }
        );
        const body = await response.json();
        console.log(Number(body.rates["EGP"]).toFixed(2));
        this.commit("setUSDRate", Number(body.rates["EGP"]));
      } catch (error) {
        console.log("err", error);
        this.commit("setUSDRate", -1);
      }
    },
    async fetchClientData() {
      this.commit("selClientDataLoaded", false);
      try {
        const response = await fetch("https://client-api-z59f.onrender.com", {
          method: "GET",
        });
        const body = await response.json();
        this.commit("setClientData", body);
      } catch (error) {
        console.log(`Error In FetchClient Data ${error}`);
        this.commit("setClientData", clients);
      }
      this.commit("selClientDataLoaded", true);
    },
  },
  modules: {},
});
